import { StepperProvider } from "../../stepper/context/StepperContext";
import { STEPS } from "../../stepper/context/StepsProvider";
import { Stepper } from "../../stepper/Stepper";

export const FormPage = () => {
    return <div>
        <StepperProvider>
            <Stepper steps={STEPS}/>
        </StepperProvider>
    </div>;
}